import {protectedAxiosInstance} from "./AxiosInstance";

export const get = async (endpoint, queryParams = {}, options) => {
  const res = await protectedAxiosInstance.get(`/api${endpoint}`, {
    params: queryParams,
    ...options,
  });
  return res.data;
};

export const post = async (endpoint, body = {}, queryParams = {}, options) => {
  const res = await protectedAxiosInstance.post(`/api${endpoint}`, body, {
    params: queryParams,
    ...options,
  });
  return res.data;
};

export const patch = async (endpoint, body = {}, queryParams = {}, options) => {
  const res = await protectedAxiosInstance.patch(`/api${endpoint}`, body, {
    params: queryParams,
    ...options,
  });
  return res.data;
};

export const put = async (endpoint, body = {}, queryParams = {}) => {
  const res = await protectedAxiosInstance.put(`/api${endpoint}`, body, {
    params: queryParams,
  });
  return res.data;
};

export const del = async (endpoint) => {
  const res = await protectedAxiosInstance.delete(`/api${endpoint}`);
  return res.data;
};
